// extracted by mini-css-extract-plugin
module.exports = {"main":"Card_main__oLGZ6"};